import { CompanyFormState } from "shared/utils/fieldsHelper/companyFields";
import { MergeFormSection } from "components/MainSectionTemplate/types";
import React from "react";

export const addressSection = (
  existingCompany: CompanyFormState,
  sourceCompany: CompanyFormState,
  currentCompany: CompanyFormState,
  setCurrentCompany: (company: CompanyFormState) => void
): MergeFormSection => ({
  key: "address",
  title: RESX.Company.VisitingAddress,
  fields: [{
    key: "companyName",
    label: RESX.Company.CompanyName,
    currentValue: currentCompany.address.visitingAddress.companyName,
    existingValue: existingCompany.address.visitingAddress.companyName,
    sourceValue: sourceCompany.address.visitingAddress.companyName,
    isEmpty: (v) => !v,
    render: (value) => <span>{value}</span>,
    onSourceClick: () => setCurrentCompany({
      ...currentCompany,
      address: {
        ...currentCompany.address,
        visitingAddress: {
          ...currentCompany.address.visitingAddress,
          companyName: sourceCompany.address.visitingAddress.companyName,
        },
      },
    }),
    onExistingClick: () => setCurrentCompany({
      ...currentCompany,
      address: {
        ...currentCompany.address,
        visitingAddress: {
          ...currentCompany.address.visitingAddress,
          companyName: existingCompany.address.visitingAddress.companyName,
        },
      },
    }),
  }, {
    key: "addressLine1",
    label: RESX.Address.AddressLine + " 1",
    currentValue: currentCompany.address.visitingAddress.addressLine1,
    existingValue: existingCompany.address.visitingAddress.addressLine1,
    sourceValue: sourceCompany.address.visitingAddress.addressLine1,
    isEmpty: (v) => !v,
    render: (value) => <span>{value}</span>,
    onSourceClick: () => setCurrentCompany({
      ...currentCompany,
      address: {
        ...currentCompany.address,
        visitingAddress: {
          ...currentCompany.address.visitingAddress,
          addressLine1: sourceCompany.address.visitingAddress.addressLine1,
        },
      },
    }),
    onExistingClick: () => setCurrentCompany({
      ...currentCompany,
      address: {
        ...currentCompany.address,
        visitingAddress: {
          ...currentCompany.address.visitingAddress,
          addressLine1: existingCompany.address.visitingAddress.addressLine1,
        },
      },
    }),
  }, {
    key: "addressLine2",
    label: RESX.Address.AddressLine + " 2",
    currentValue: currentCompany.address.visitingAddress.addressLine2,
    existingValue: existingCompany.address.visitingAddress.addressLine2,
    sourceValue: sourceCompany.address.visitingAddress.addressLine2,
    isEmpty: (v) => !v,
    render: (value) => <span>{value}</span>,
    onSourceClick: () => setCurrentCompany({
      ...currentCompany,
      address: {
        ...currentCompany.address,
        visitingAddress: {
          ...currentCompany.address.visitingAddress,
          addressLine2: sourceCompany.address.visitingAddress.addressLine2,
        },
      },
    }),
    onExistingClick: () => setCurrentCompany({
      ...currentCompany,
      address: {
        ...currentCompany.address,
        visitingAddress: {
          ...currentCompany.address.visitingAddress,
          addressLine2: existingCompany.address.visitingAddress.addressLine2,
        },
      },
    }),
  }, {
    key: "postalCode",
    label: RESX.Address.PostalCode,
    currentValue: currentCompany.address.visitingAddress.postalCode,
    existingValue: existingCompany.address.visitingAddress.postalCode,
    sourceValue: sourceCompany.address.visitingAddress.postalCode,
    isEmpty: (v) => !v,
    render: (value) => <span>{value}</span>,
    onSourceClick: () => setCurrentCompany({
      ...currentCompany,
      address: {
        ...currentCompany.address,
        visitingAddress: {
          ...currentCompany.address.visitingAddress,
          postalCode: sourceCompany.address.visitingAddress.postalCode,
        },
      },
    }),
    onExistingClick: () => setCurrentCompany({
      ...currentCompany,
      address: {
        ...currentCompany.address,
        visitingAddress: {
          ...currentCompany.address.visitingAddress,
          postalCode: existingCompany.address.visitingAddress.postalCode,
        },
      },
    }),
  }, {
    key: "city",
    label: RESX.Address.City,
    currentValue: currentCompany.address.visitingAddress.city,
    existingValue: existingCompany.address.visitingAddress.city,
    sourceValue: sourceCompany.address.visitingAddress.city,
    isEmpty: (v) => !v,
    render: (value) => <span>{value}</span>,
    onSourceClick: () => setCurrentCompany({
      ...currentCompany,
      address: {
        ...currentCompany.address,
        visitingAddress: {
          ...currentCompany.address.visitingAddress,
          city: sourceCompany.address.visitingAddress.city,
        },
      },
    }),
    onExistingClick: () => setCurrentCompany({
      ...currentCompany,
      address: {
        ...currentCompany.address,
        visitingAddress: {
          ...currentCompany.address.visitingAddress,
          city: existingCompany.address.visitingAddress.city,
        },
      },
    }),
  }, {
    key: "country",
    label: RESX.Address.Country,
    currentValue: currentCompany.address.visitingAddress.country,
    existingValue: existingCompany.address.visitingAddress.country,
    sourceValue: sourceCompany.address.visitingAddress.country,
    isEmpty: (v) => !v,
    render: (value: server.dto.Country) => <span>{value.name}</span>,
    onSourceClick: () => setCurrentCompany({
      ...currentCompany,
      address: {
        ...currentCompany.address,
        visitingAddress: {
          ...currentCompany.address.visitingAddress,
          country: sourceCompany.address.visitingAddress.country,
        },
      },
    }),
    onExistingClick: () => setCurrentCompany({
      ...currentCompany,
      address: {
        ...currentCompany.address,
        visitingAddress: {
          ...currentCompany.address.visitingAddress,
          country: existingCompany.address.visitingAddress.country,
        },
      },
    }),
  }, {
    key: "state",
    label: RESX.Address.State,
    currentValue: currentCompany.address.visitingAddress.state,
    existingValue: existingCompany.address.visitingAddress.state,
    sourceValue: sourceCompany.address.visitingAddress.state,
    isEmpty: (v) => !v,
    render: (value: server.dto.State) => <span>{value.name}</span>,
    onSourceClick: () => setCurrentCompany({
      ...currentCompany,
      address: {
        ...currentCompany.address,
        visitingAddress: {
          ...currentCompany.address.visitingAddress,
          state: sourceCompany.address.visitingAddress.state,
        },
      },
    }),
    onExistingClick: () => setCurrentCompany({
      ...currentCompany,
      address: {
        ...currentCompany.address,
        visitingAddress: {
          ...currentCompany.address.visitingAddress,
          state: existingCompany.address.visitingAddress.state,
        },
      },
    }),
  }]
});